import { Box, Button, Chip, Typography } from "@mui/material";
import React from "react";
import { COLORS } from "../../constants";

interface SectionHeaderProps {
  title: string;
  count?: number;
  onViewAll?: () => void;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  count,
  onViewAll,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          color: COLORS.textPrimary,
          lineHeight: 1.4,
        }}
      >
        {title}
      </Typography>
      {count !== undefined && count > 0 && (
        <Chip
          label={count}
          size="small"
          color="error"
          sx={{
            height: "18px",
            fontSize: "11px",
            fontWeight: 600,
            "& .MuiChip-label": { px: 0.75 },
          }}
        />
      )}
    </Box>
    {onViewAll && (
      <Button
        size="small"
        sx={{
          color: COLORS.primary,
          textTransform: "none",
          fontSize: "13px",
          fontWeight: 500,
          minWidth: "auto",
          px: 0.5,
          "&:hover": {
            backgroundColor: "transparent",
            textDecoration: "underline",
          },
        }}
        onClick={onViewAll}
      >
        View All
      </Button>
    )}
  </Box>
);

export default SectionHeader;
